import { render, staticRenderFns } from "./ChangeUserData.vue?vue&type=template&id=80489a8a"
import script from "./ChangeUserData.vue?vue&type=script&lang=js"
export * from "./ChangeUserData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports